import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Tree from 'react-d3-tree';
import HttpClient from '../../myapi';
import { IconPersonAdd } from '../../Icons';
import NewPersonMd from './NewPersonMd';
import Button from '@material-ui/core/Button/Button';
import Fade from '@material-ui/core/Fade/Fade';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography/Typography';
import Store from '../../redux/store/index';
import { bkupPersons } from '../../redux/actions';

// const svgNode = {
//     shape: 'rect',
//     shapeProps: {
//         fill: 'blue',
//         width: 30,
//         height: 30,
//         x: -15,
//         y: -15,
//         // strokeWidth: 1,
//     },
// };
// const nameStyle = {
//     fontSize: 12,
//     fill: '#3366ff',
//     fontWeight: '600',
//     strokeWidth: 0,
//     textLength: 100,
//     lengthAdjust: 'spacing',
// };
const container = {
    width: '100%',
    minHeight: 400,
    height: '87vh',
    background: '#fff',
};
const styles = {
    links: {
        stroke: '#2828a4',
        strokeWidth: 1,
    },
    nodes: {
        node: {
            circle: {
                fill: '#3333cc',
                strokeWidth: 1,
            },
        },
        leafNode: {
            circle: {
                stroke: '#3333cc',
            },
        },
    },
};
class TreeView extends Component {
    state = { tree: [], showInfo: false, infoData: {}, newPersonModal: false };

    componentDidMount() {
        this.getData();
        this.getPersons();
    }
    getPersons = () => {
        HttpClient.get('/Persons/getPersons').then(res => {
            this.setState({
                persons: res,
            });

            //BKUP IN STORE
            Store.dispatch(bkupPersons(res));
        });
    };

    showNewPersonModal = () => {
        this.setState({ newPersonModal: !this.state.newPersonModal });
    };

    getData() {
        HttpClient.get('/Pins/getTree').then(res => {
            this.setState({
                tree: res.children,
            });
        });
    }

    showInfo = data => {
        this.setState({
            showInfo: !this.state.showInfo,
            infoData: data,
        });
    };

    render() {
        return (
            <Grid justify="center" container>
                <Grid style={container} sm={12} md={12} lg={10} item>
                    <UserInfo
                        open={this.state.showInfo}
                        info={this.state.infoData}
                    />
                    {this.state.tree.length && (
                        <Tree
                            data={this.state.tree}
                            //nodeSvgShape={svgNode}
                            orientation="vertical"
                            zoom={1}
                            transitionDuration={0}
                            pathFunc="elbow"
                            depthFactor={80}
                            translate={{ x: 600, y: 250 }}
                            styles={styles}
                            onMouseOver={this.showInfo}
                            onMouseOut={this.showInfo}
                            allowForeignObjects
                            nodeLabelComponent={{
                                render: <NodeLabel />,
                                foreignObjectWrapper: {
                                    x: 10,
                                    y: -20,
                                },
                            }}
                        />
                    )}
                </Grid>
                <Button
                        style={{
                            position: 'absolute',
                            margin: 20,
                            marginLeft: '45%',
                        }}
                        color="primary"
                        variant="fab"
                        onClick={this.showNewPersonModal}
                    >
                        <IconPersonAdd />
                    </Button>
                    {this.state.newPersonModal && (
                    <NewPersonMd
                        closeModal={this.showNewPersonModal}
                        onsuccess={() => this.getData()}
                        open={true}
                    />
                )}
            </Grid>
        );
    }
}
export default TreeView;

const style2 = {
    wrapper: {
        // backgroundColor: 'rgba(255, 0,0 , 0.8)',
        width: 60,
        // height: 20
    },
    p1: {
        fontSize: 14,
        margin: 0,
        width: 70,
        color: '#3366ff',
    },
    p2: {
        fontSize: 12,
        color: '#444',
        margin: 0,
        marginTop: 2,
    },
};
class NodeLabel extends React.Component {
    render() {
        const { nodeData } = this.props;

        return (
            <div style={style2.wrapper}>
                <Typography style={style2.p1} variant="body2" noWrap={true}>
                    {nodeData.name}
                </Typography>
                <p style={style2.p2}>{nodeData.pin}</p>
            </div>
        );
    }
}

const ustyles = {
    chip: {
        position: 'absolute',
        padding: 8,
        margin: 4,
        backgroundColor: '#0040ff',
        minWidth: 300,
        color: '#fff',
    },
    text: {
        color: '#fff',
    },
};
const UserInfo = withStyles(ustyles)(({ classes, info, open }) => (
    <Fade in={open}>
        <div className={classes.chip}>
            <Typography variant="subtitle2" className={classes.text}>
                {info.name} ({info.pin})
            </Typography>
            <Typography variant="caption" className={classes.text}>
                {info.city}, Level: {info.level}
            </Typography>
        </div>
    </Fade>
));
